import { Anchor as MantineAnchor } from '@mantine/core'

// Polymorphic passthrough: re-exported as-is so callers keep Mantine's
// `component`/`to` typing (e.g. rendering it as a react-router <Link>). App code
// must import Anchor from @percent/lemonade, never from @mantine/core directly.
export const Anchor = MantineAnchor
